import React, { ReactElement } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import HomeDashboard from "../features/dashboard/Dashboard";
import LeadExplorer from "../features/leads/Leads";
import DashboardLayout from "../components/layout/Dashboard/DashboardLayout";
import ListsDashboard from "../features/lists/ListsDashboard";
import CompanyExplorer from "../features/company/CompanyExplorer";

function DashboardRoutes(): ReactElement {
  return (
    <BrowserRouter>
      <Routes>
        {/* The DashboardLayout wraps all internal routes to provide the Sidebar and Topbar */}
        <Route element={<DashboardLayout />}>
          {/* Matches the "Home" nav item */}
          <Route path="/" element={<HomeDashboard />} />

          {/* Matches the "People" nav item in the sidebar */}
          <Route path="/people" element={<LeadExplorer />} />
          <Route path="/companies" element={<CompanyExplorer />} />
          <Route path="/lists" element={<ListsDashboard />} />

          {/* You can add /companies, /lists, /analytics here later */}
        </Route>

        {/* Catch-all: redirects any unknown dashboard routes back to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default DashboardRoutes;
